<mat-sidenav-container dir="ltr">
    <mat-sidenav #sidenav mode="over" [(opened)]="showMenu" position="end" class="side-nav" fixedInViewport="true">
        <app-side-nav-item (closeSideNav)="toggleMenu()" />
    </mat-sidenav>
    <mat-sidenav-content class="h-full flex flex-row" autosize>
        <app-header class="full-size" (menu)="toggleMenu()" />
        <router-outlet class="full-size" />
        <app-footer class="full-size" />
    </mat-sidenav-content>
</mat-sidenav-container>